import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NgScrollbarModule } from 'ngx-scrollbar';

const menuList = [
  {
    name: 'Dashboard',
    link: ['/', 'mda'],
    type: 'All',
    exact: true,
    icon: 'assets/svgs/menu/dashboard.svg',
  },
  {
    name: 'Invoice Report',
    link: ['/', 'mda', 'invoice-reports'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/menu/file-text.svg',
  },
  {
    name: 'Collection Report',
    link: ['/', 'mda', 'collection-reports'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/menu/hard-drive.svg',
  },
  {
    name: 'Revenue Heads Report',
    link: ['/', 'mda', 'revenue-reports'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/menu/report.svg',
  },
];

const menuList2 = [
  {
    name: 'Settings',
    link: `/mda/settings`,
    type: 'All',
    exact: false,
    icon: 'assets/svgs/settings.svg',
  },
  {
    name: 'Log Out',
    link: '/',
    type: 'Danger',
    exact: true,
    icon: 'assets/svgs/menu/log-out.svg',
  },
];

@Component({
  selector: 'app-mda-sidemenu',
  standalone: true,
  imports: [
    SvgIconComponent,
    NzToolTipModule,
    RouterModule,
    NgScrollbarModule,
    CommonModule,
    NzMenuModule,
  ],
  templateUrl: './mda-sidemenu.component.html',
  styleUrl: './mda-sidemenu.component.css',
})
export class MdaSidemenuComponent {
  @Input({ required: true }) isCollapsed = false;

  menuList = signal(menuList);
  menuList2 = signal(menuList2);
}
